import React, { useEffect } from "react";
import "../styles/footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const logoX =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/x.svg";
const logoInstagram =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/footericons/instagram.svg";
export default function Footer() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <hr className="footerhr" />
      <div className="dashboardfooter">
        <div className="dashboardfootercolumn">
          <h3>Neurogen</h3>
          <ul>
            <li>© Neuroverse Healthcare</li>
            <li onClick={() => navigate("/contact")}>Contact Us</li>
            <li
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              Privacy Policy
            </li>

            <li onClick={() => navigate("/terms")}>Terms and Conditions</li>
            <li onClick={() => navigate("/cancellation-policy/")}>
              Cancellation/Refund Policy
            </li>
          </ul>
        </div>
        <div className="dashboardfootercolumn">
          <h3>Disclosure</h3>
          <p>Large language model technology is experimental.</p>
          <p>
            All outputs are for educational purposes only and should not be used
            for patient care.
          </p>
          <p>
            As an online educational platform, we do not provide shipping or
            delivery services.
          </p>
        </div>
        <div className="dashboardfootercolumn dashboardfootercolumnemail">
          <h3>Contact</h3>
          <p>Neuroverse.healthcare@gmail.com</p>
          <p>Business Name : SHIV VIRMANI</p>
        </div>
        <div className="dashboardfootercolumn">
          <h3>Socials</h3>
          <div className="dashboardfootersocialrow">
            <ul>
              <a
                href="https://www.instagram.com/neurogen.app/profilecard/?igsh=MW4wcW93emFpamprZQ=="
                target="_blank"
              >
                <li>
                  <img src={logoInstagram} alt="Instagram" />
                </li>
              </a>
              <a
                href="https://x.com/neurogenapp/status/1856551952718671888?s=46"
                target="_blank"
              >
                <li>
                  <img src={logoX} alt="X" />
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
